import React, { useState, useEffect } from "react";
import { Table, message, Card, Avatar, Typography, Tag } from "antd";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const ManagersList = () => {
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const fetchManagers = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Manager/GetListAll`, {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch managers");
      }

      const data = await response.json();
      setManagers(data);
    } catch (error) {
      console.error("Error fetching managers:", error);
      message.error("Failed to load managers data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManagers();
  }, []);

  const columns = [
    {
      title: "Manager",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            src={record.profileImage ? `${baseImageUrl}${record.profileImage}` : null}
            icon={!record.profileImage && <UserOutlined />}
            size="large"
            style={{
              backgroundColor: record.profileImage ? "transparent" : "#f56a00",
            }}
          />
          <div>
            <Text strong>
              {record.firstName} {record.lastName}
            </Text>
            <br />
            <Text type="secondary">{record.email}</Text>
          </div>
        </div>
      ),
    },
    {
      title: "Contact",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Business Group",
      dataIndex: "businessGroupName",
      key: "businessGroupName",
      render: (text, record) =>
        record.hasBusinessGroup ? (
          <Tag color="blue">{text}</Tag>
        ) : (
          <Tag color="default">Not assigned</Tag>
        ),
    },
    {
      title: "Profile Status",
      dataIndex: "isProfileDetailCompleted",
      key: "isProfileDetailCompleted",
      render: (completed) => (
        <Tag color={completed ? "green" : "orange"}>{completed ? "Completed" : "Incomplete"}</Tag>
      ),
      filters: [
        { text: "Completed", value: true },
        { text: "Incomplete", value: false },
      ],
      onFilter: (value, record) => record.isProfileDetailCompleted === value,
    },
    {
      title: "Date Joined",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) => new Date(a.createdOn) - new Date(b.createdOn),
    },
  ];

  return (
    <Card className="card-professional" title="Managers List" bordered={false}>
      <Table
        columns={columns}
        dataSource={managers}
        rowKey="managerId"
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default ManagersList;
